var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['user-card' ]},[_c('div',{staticClass:"user-media"},[_c('img',{attrs:{"src":_vm.image}})]),_c('span',{staticClass:"user-title"},[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }